import styled from 'styled-components';
import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

export const BtmCtn = styled.div`
  > div {
    font-size: 40px;
    line-height: 40px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 35px;
      line-height: 35px;
    `}
  }

  > span {
    font-size: 15px;
    font-weight: bold;
    color: ${THEME.colors.secondaryFontColor};

    ${Media.Below.desktop`
      font-size: 13px;
    `}
  }
`;

export const CardCtn = styled.div`
  flex: 0 0 16%;
  max-width: 200px;
  min-width: 190px;
  height: 175px;
  margin-bottom: 25px;

  ${Media.Below.desktop`
    flex: 0 0 20%;
    max-width: 150px;
    min-width: 140px;
    height: 125px;
    margin-bottom: 20px;
  `}

  ${Media.Below.mobileLarge`
    flex: 0 0 45%;
    max-width: 180px;
    height: 138px;
    margin-bottom: 20px;
  `}
`;

export const CardBody = styled.div`
  background-color: ${THEME.colors.secondaryBackgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  height: 100%;
  width: 100%;
  padding: 17px;
  background-color: white;
  box-shadow: 0 3px 20px 0 rgba(86, 86, 91, 0.15);
`;

export const SvgCtn = styled.div`
  height: 30px;

  ${Media.Below.desktop`
    height: 25px;
  `}

  > img {
    height: 100%;
  }
`;

export const TopCtn = styled.div`
  display: flex;
  justify-content: flex-end;
`;
